<template>
    <div class="relative w-full p-4 mt-4  md:p-8">
        <div class="flex justify-center">
            <div>
                <div class="bg-center bg-cover rounded-full w-18 md:w-26 h-18 md:h-26"
                    :style="{ backgroundImage: avatarSrc }">
                </div>
            </div>

            <div class="ml-3 md:ml-6">
                <div class="text-xs text-grey-400">
                    <i>Your Unbundled Lawyer is:</i>
                </div>

                <div class="font-bold text-brand-blue" v-text="tenant.display_contact_name"></div>

                <div class="text-sm">
                    <div>{{ tenant.organization }}</div>

                    <template v-if="isProfile">
                        <div>{{ tenant.address_1 }}</div>

                        <template v-if="tenant.address_2">
                            <div>{{ tenant.address_2 }}</div>
                        </template>

                        {{ tenant.city }}, {{ tenant.state.abbreviation }} {{ tenant.postcode }} {{ tenant.country.alpha2 }}
                    </template>
                </div>

                <div class="flex items-center mt-2 text-xs text-grey-400">
                    <i class="mr-2 text-xl fas fa-envelope-open-text text-brand-blue"></i>

                    <i>We&rsquo;ve sent this to your email inbox, too!</i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            avatarSrc() {
                return `url('${this.tenant.avatar_url}')`;
            },

            ...mapGetters([
                'isProfile',
                'tenant'
            ])
        }
    }
</script>
